<template>
  <div class="ServiceSupport">
    <div class="ProductImge">
      <el-carousel :interval="5000" height="280px">
        <el-carousel-item v-for="(item, index) in swiperList" :key="index">
          <img :src="item.showImgUrl" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="introductionBox">
      <div class="introduction-mian" v-if="ProductList.length > 0">
        <div class="introduction_L">
          <div class="introductiontitle">产品发布</div>
          <div class="introductionItem">
            <div
              :class="['menuItem', currentIndex == index ? 'currentItem' : '']"
              v-for="(item, index) in ProductList"
              :key="index"
              @click="selectMenu(index)"
            >
              <div class="menuName">
                {{ item.navigationTwoClassPojo.twoClassName }}
              </div>
            </div>
            <!-- <el-menu :default-active="currentTwo" v-for="(item,index) in ProductList" :key="index" @select="selectMenu" class="el-menu-vertical-demo"  text-color="#fff" active-text-color="#fff">
              <el-menu-item :index="item.indexs">
                <span slot="title">{{item.navigationTwoClassPojo.twoClassName}}</span>
              </el-menu-item>
            </el-menu> -->
          </div>
        </div>
        <div class="introduction_r">
          <div class="introduction_nameBox">
            <div class="introduction_name">产品发布</div>
          </div>
          <div class="introduction_cont">
            <div
              class="videoItem"
              v-for="(item, index) in ContentList"
              :key="index"
              @click="toDetail(item.videoId, item.videoName)"
            >
              <div class="videoBox">
                <video
                  class="video"
                  :src="item.videoLink"
                  :poster="item.img"
                  controls
                ></video>
              </div>
              <div class="videoInfo">
                <div class="videoTitle">{{ item.videoName }}</div>
                <div class="releaseTime">
                  发布时间：{{ item.createTime | dateFilter("YYYY-MM-DD") }}
                </div>
              </div>
            </div>
          </div>
          <div class="paginationBox">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="totalElement"
              @current-change="currentPage"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: 0,
      currentTwo: "0",
      // currentOne:0,
      ProductList: [],
      page: 1,
      limit: 10,
      ContentList: [],
      contentId: "",
      contentName: "",
      totalElement: 1,
      twoClassName: "",
      swiperList: [],
      oneClassId: -1,
    };
  },
  mounted() {
    this.getProductList();
    this.getbackground();
  },
  methods: {
    selectMenu(index) {
      // let index = e-1;
      this.currentIndex = index;
      this.oneClassId =
        this.ProductList[index].navigationTwoClassPojo.twoClassId;
      this.getVideoList();
    },
    getbackground() {
      let url = "/navigationController/front/searchNavigationShowImg";
      this.$axios
        .get(url, {
          params: {
            type: 6,
          },
        })
        .then((res) => {
          console.log(res);
          this.swiperList = res.data.data;
        });
    },
    toDetail(id, oneTitle) {
      this.$router.push({
        path: "/product-Item",
        query: { contentId: id, contentName: oneTitle, PageType: 1 },
      });
    },
    currentPage(e) {
      this.page = e;
      this.getVideoList();
    },
    //视频列表
    getVideoList() {
      if (this.oneClassId == -1) {
        this.oneClassId = this.ProductList[0].navigationTwoClassPojo.twoClassId;
      }
      let url = "/videoController/back/searchVideoPage";
      this.$axios
        .post(url, {
          oneClassId: this.oneClassId,
          page: this.page,
          limit: this.limit,
        })
        .then((res) => {
          console.log(res);
          this.ContentList = res.data.data;
          this.totalElement = res.data.totalElement;
        });
    },
    //左边菜单
    getProductList() {
      let url = "/videoController/front/searchVideoClassList";
      this.$axios.get(url).then((res) => {
        console.log(res);
        this.ProductList = res.data.data.map((cur, index) => {
          cur.indexs = (index + 1).toString();
          return cur;
        });
        this.getVideoList();
        // console.log(this.ProductList)
      });
    },
  },
};
</script>

<style scoped lang="less">
.product-Item {
  .introduction_r {
    width: calc(1200px - 304px);
    .introduction_nameBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 30px 0;
      // margin-bottom: 30px;
      border-bottom: 1px solid #e6e8ed;
      .introduction_name {
        font-size: 30px;
        font-family: NotoSansHans-Regular, NotoSansHans;
        font-weight: 400;
        color: #333333;
      }
      .inputBox {
        width: 360px;
        height: 36px;
        // background: #FFFFFF;
        border-radius: 4px;
        // border: 1px solid #1373CF;
      }
    }
  }
}
.Product-introduction {
  width: calc(1200px - 304px);
}
.Product-title {
  font-size: 30px;
  font-family: NotoSansHans-Regular, NotoSansHans;
  font-weight: 400;
  color: #333333;
  line-height: 45px;
  letter-spacing: 2px;
  padding: 30px 0;
  border-bottom: 1px solid #e6e8ed;
}
.Product-main {
  padding: 30px 0;
}
.Product-item {
  display: flex;
  /* align-items: center; */
  margin-bottom: 10px;
  cursor: pointer;
}
.paginationBox {
  display: flex;
  justify-content: center;
  padding: 30px 0;
}
.Product-image {
  width: 80px;
  height: 80px;
  margin-right: 22px;
}
.Product-image > img {
  width: 100%;
  height: 100%;
}
.Product-right {
  width: calc(100% - 102px);
  padding: 7px 0;
  border-bottom: 1px solid #e6e8ed;
}
.Product-name {
  font-size: 18px;
  font-family: NotoSansHans-Medium, NotoSansHans;
  font-weight: 500;
  color: #333333;
  line-height: 27px;
  letter-spacing: 2px;
  margin-bottom: 5px;
}
.Product-dsc {
  font-size: 14px;
  font-family: NotoSansHans-Regular, NotoSansHans;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  letter-spacing: 2px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.ImageItemWrap {
  margin-right: 24px;
}
.ImageItemWrap:nth-child(3n + 3) {
  margin-right: 0;
}
.ServiceSupport {
  .ProductImge {
    width: 100%;
    height: 280px;
    // background: lightcoral;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .introductionBox {
    width: 100%;
    height: auto;
    margin-bottom: 148px;
    .introduction-mian {
      display: flex;
      width: 1200px;
      margin: 0 auto;
      .introduction_L {
        width: 204px;
        height: auto;
        margin-right: 100px;
        .introductiontitle {
          width: 203px;
          height: 80px;
          background: #1373cf;
          font-size: 24px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          color: #ffffff;
          text-align: center;
          line-height: 80px;
          cursor: pointer;
        }
        .introductionItem {
          .menuItem {
            height: 56px;
            background: rgb(67, 144, 217);
            text-align: center;
            border-bottom: 1px solid #ffffff;
            .menuName {
              color: #ffffff;
              font-size: 14px;
              cursor: pointer;
              line-height: 56px;
            }
          }
          .currentItem {
            background: #9fc6ea;
            // color: rgb(19, 115, 207);
          }
          .currentItem .menuName {
            color: rgb(19, 115, 207);
          }
          // /deep/.el-submenu__title i{
          //   color:#fff;
          // }
          // /deep/.el-menu-item{
          //   background: rgb(67, 144, 217) !important;
          //   border-bottom: 1px solid #fff;
          //   text-align: center;
          // }
        }
        // .current{
        //   background: #1373CF;
        //   opacity: 0.5;

        // }
      }
      .introduction_r {
        width: calc(1200px - 304px);
        .introduction_nameBox {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 30px 0;
          // margin-bottom: 30px;
          border-bottom: 1px solid #e6e8ed;
          .introduction_name {
            font-size: 30px;
            font-family: NotoSansHans-Regular, NotoSansHans;
            font-weight: 400;
            color: #333333;
          }
          .inputBox {
            width: 360px;
            height: 36px;
            // background: #FFFFFF;
            border-radius: 4px;
            // border: 1px solid #1373CF;
          }
        }
        .introduction_cont {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          padding: 20px 0;
          .videoItem {
            width: 282px;
            height: 244px;
            // background: cadetblue;
            margin-right: 24px;
            margin-bottom: 24px;
            // border: 1px solid #f5f5f5;
            box-sizing: border-box;
            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
            cursor: pointer;
            .videoBox {
              width: 282px;
              height: 160px;
              .video {
                width: 100%;
                height: 100%;
              }
            }
            .videoInfo {
              width: 282px;
              padding: 20px 8px;
              box-sizing: border-box;
              .videoTitle {
                font-size: 18px;
                font-family: NotoSansHans-Medium, NotoSansHans;
                font-weight: 500;
                color: #333333;
                line-height: 27px;
                // letter-spacing: 2px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                margin-bottom: 8px;
              }
              .releaseTime {
                font-size: 14px;
                font-family: NotoSansHans-Regular, NotoSansHans;
                font-weight: 400;
                color: #999999;
                line-height: 21px;
                // letter-spacing: 2px;
              }
            }
          }
          .videoItem:nth-child(3n + 3) {
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>